import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { Observable } from "rxjs";
import { pluck, map } from "rxjs/operators";

import { TeamPageSettingsService } from "../../team-page-settings.service";
import {
  UserSummaryContactService,
  UserSummaryContact
} from "@onsip/common/services/api/resources/userSummaryContact/user-summary-contact.service";
import { OrganizationCustomizationService } from "@onsip/common/services/api/resources/organizationCustomization/organization-customization.service";

@Component({
  selector: "onsip-preview",
  template: "<div></div>",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TeamSettingsPreviewContentComponent implements OnInit {
  accentColor!: Observable<string>;
  blurb!: Observable<string>;
  domain!: Observable<string>;
  greeting!: Observable<string>;
  teamMembers!: Observable<Array<UserSummaryContact>>;
  logo!: Observable<string>;

  imgLink = "resources/img/sayso-preview/web-preview.svg";

  constructor(
    protected settings: TeamPageSettingsService,
    protected userSummaryContact: UserSummaryContactService,
    protected organizationCustomization: OrganizationCustomizationService
  ) {}

  ngOnInit(): void {
    this.teamMembers = this.userSummaryContact.state.pipe(
      map(substate =>
        Object.values(substate.state)
          .filter(user => user.teamPageVisible)
          .sort((a, b) => (a.contactName.toUpperCase() > b.contactName.toUpperCase() ? 1 : -1))
      )
    );
    this.domain = this.settings.teamInfoSubject.pipe(pluck("domain"));
    this.accentColor = this.organizationCustomization.organization.pipe(
      map(organizationCustomization => {
        const accentColor = organizationCustomization.organizationInfo?.teamPageInfo?.accentColor;
        return typeof accentColor === "string" ? accentColor : "#6b80ff"; // lazy hardcode from team page color picker component
      })
    );

    this.blurb = this.settings.teamInfoSubject.pipe(pluck("blurb"));
    this.greeting = this.settings.teamInfoSubject.pipe(pluck("greeting"));
    this.logo = this.settings.teamInfoSubject.pipe(pluck("logo"));
  }
}
